import { render, staticRenderFns } from "./pointOrderDetail.vue?vue&type=template&id=a3ebe1c2&scoped=true&"
import script from "./pointOrderDetail.vue?vue&type=script&lang=js&"
export * from "./pointOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointOrderDetail.vue?vue&type=style&index=0&id=a3ebe1c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ebe1c2",
  null
  
)

export default component.exports